import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import VisualQa from './VisualQa'
import DeveloperExperiencePage from './DeveloperExperiencePage';

import {   
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

ReactDOM.render(
  <Router>
    <Switch>
      <Route path="/explorer">
        <DeveloperExperiencePage />
      </Route>
      <Route path="/tracer">
        <DeveloperExperiencePage />
      </Route>
      <Route path="/visualizer">
        <DeveloperExperiencePage />
      </Route>
      <Route path="/home">
        <App />
      </Route>
      <Route path="/visualqa">
        <VisualQa />
      </Route>
      <Route path="/">
        <DeveloperExperiencePage />
      </Route>
    </Switch>
  </Router>,
  document.getElementById('root')
);
